import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, mergeMap, switchMap } from "rxjs/operators";
import { DeviceActions } from "../actions";
import { DeviceService } from "../services";

@Injectable()
export class DeviceEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly deviceService: DeviceService
  ) {}

  loadDevices$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DeviceActions.loadDevices),
      // devices$() never completes (it keeps watching devicechange): a later load must
      // replace it, not queue behind it forever.
      switchMap(() =>
        this.deviceService.devices$().pipe(
          mergeMap((_) => [DeviceActions.loadDevicesSuccess({ devices: _ })]),
          catchError((_) => [DeviceActions.loadDevicesFailure({ error: _ })])
        )
      )
    )
  );
}
